<div
  role="radiogroup"
  class="radio-group"
  [attr.aria-labelledby]="labelledBy"
  [attr.aria-describedby]="describedBy"
  [attr.aria-invalid]="hasError"
>
  <nx-ng-radio-group-item
    *ngFor="let item of standard; trackBy: trackByFn"
    class="radio-item"
    [id]="describedBy"
    [item]="item"
    [groupName]="groupName"
    [selected]="selected"
    [showMoreInfoText]="showMoreInfoText"
    (selection)="handleSelection($event)"
    (action)="handleAction($event)"
    (blur)="handleBlur()"
  >
  </nx-ng-radio-group-item>

  <div class="separator" *ngIf="additional && additional.length > 0">
    <span *ngIf="separatorLabelKey"> {{ separatorLabelKey | i18next }} </span>
  </div>

  <nx-ng-radio-group-item
    *ngFor="let item of additional; trackBy: trackByFn"
    class="radio-item"
    [id]="describedBy"
    [item]="item"
    [groupName]="groupName"
    [selected]="selected"
    [showMoreInfoText]="showMoreInfoText"
    (selection)="handleSelection($event)"
    (action)="handleAction($event)"
    (blur)="handleBlur()"
  >
  </nx-ng-radio-group-item>
</div>
